import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StagePopup({ x, y, stage, stageName, swatch, range, popupDate, popupMin, popupMax, len, onClose, onSetName, onSetStart, onSetLen, onDelete, }) {
    return (_jsxs("div", { "data-menu-keep": "1", "data-seg-keep": "1", style: {
            position: 'fixed',
            left: x,
            top: y,
            zIndex: 55,
            width: 250,
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: 12,
            boxShadow: '0 12px 32px rgba(15,23,42,.22)',
            padding: 14,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
        }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsx("span", { style: { width: 12, height: 12, borderRadius: 3, background: swatch, flex: 'none' } }), _jsx("span", { style: { fontSize: 13, fontWeight: 700, flex: 1 }, children: stage }), _jsx("button", { type: "button", onClick: onClose, className: "kp-option", style: {
                            border: 'none',
                            background: 'none',
                            color: '#94A3B8',
                            fontSize: 14,
                            cursor: 'pointer',
                            padding: '2px 6px',
                            borderRadius: 5,
                        }, children: "\u2715" })] }), _jsx("div", { style: { fontSize: 11.5, color: '#64748B', marginTop: -4 }, children: range }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 5, fontSize: 11.5, fontWeight: 600, color: '#334155' }, children: ["\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", _jsx("input", { type: "text", defaultValue: stageName, placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0442\u0430\u0434\u0438\u0438", onBlur: (e) => onSetName(e.currentTarget.value), style: {
                            height: 32,
                            border: '1px solid #CBD5E1',
                            borderRadius: 7,
                            padding: '0 8px',
                            fontSize: 12.5,
                            outline: 'none',
                            width: '100%',
                        } }, stageName)] }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 5, fontSize: 11.5, fontWeight: 600, color: '#334155' }, children: ["\u0414\u0430\u0442\u0430 \u0441\u0442\u0430\u0440\u0442\u0430", _jsx("input", { type: "date", value: popupDate, min: popupMin, max: popupMax, onChange: (e) => onSetStart(e.target.value), style: {
                            height: 32,
                            border: '1px solid #CBD5E1',
                            borderRadius: 7,
                            padding: '0 8px',
                            fontSize: 12.5,
                            background: '#FFFFFF',
                            outline: 'none',
                            width: '100%',
                        } }), _jsx("span", { style: { fontSize: 10.5, fontWeight: 400, color: '#94A3B8' }, children: "\u043E\u043A\u0440\u0443\u0433\u043B\u044F\u0435\u0442\u0441\u044F \u0434\u043E \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A\u0430 \u043D\u0435\u0434\u0435\u043B\u0438" })] }), _jsxs("label", { style: { display: 'flex', flexDirection: 'column', gap: 5, fontSize: 11.5, fontWeight: 600, color: '#334155' }, children: ["\u0414\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C, \u043D\u0435\u0434", _jsx("input", { type: "number", min: 1, value: len, onChange: (e) => onSetLen(+e.target.value), style: {
                            height: 32,
                            border: '1px solid #CBD5E1',
                            borderRadius: 7,
                            padding: '0 8px',
                            fontSize: 12.5,
                            outline: 'none',
                        } })] }), _jsx("button", { type: "button", onClick: onDelete, className: "kp-danger-btn", style: {
                    height: 30,
                    border: '1px solid #FECACA',
                    borderRadius: 7,
                    background: '#FFFFFF',
                    color: '#B91C1C',
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: 'pointer',
                }, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u0430\u0434\u0438\u044E" })] }));
}
